// extracted by mini-css-extract-plugin
export var divider = "_du-7";
export var itemsToggle = "_du-8";
export var mergeModal = "_du-1";
export var optionCard = "_du-4";
export var radioGroup = "_du-6";
export var radioOption = "_du-0";
export var selected = "_du-5";
export var shipmentOptions = "_du-2";
export var tableOptions = "_du-3";